import { useEffect } from "react";
import { Card, Typography, Result } from "antd";
import CustomButton from "../../../components/CustomButton/Button";

const { Paragraph } = Typography;

const REDIRECT_DELAY_MS = 3000;

const KycSuccess = ({
  onContinue,
  isAlreadyCompleted = false,
  autoRedirect = true,
}) => {
  useEffect(() => {
    if (!autoRedirect || isAlreadyCompleted || typeof onContinue !== "function") {
      return undefined;
    }

    const timer = setTimeout(() => {
      onContinue();
    }, REDIRECT_DELAY_MS);

    return () => clearTimeout(timer);
  }, [autoRedirect, isAlreadyCompleted, onContinue]);

  return (
    <div className="complete-kyc-container">
      <Card
        className="complete-kyc-card"
        style={{ textAlign: "center", padding: "48px 24px" }}
      >
        <Result
          status="success"
          title={isAlreadyCompleted ? "KYC Already Completed" : "KYC Successful"}
          subTitle={
            isAlreadyCompleted
              ? "Your KYC has already been completed."
              : "Your KYC has been submitted successfully and is under review. We will notify you once it is approved."
          }
          extra={
            isAlreadyCompleted
              ? [
                  <CustomButton key="dashboard" color="green" onClick={onContinue}>
                    Go to Dashboard
                  </CustomButton>,
                ]
              : undefined
          }
        />
        {!isAlreadyCompleted && autoRedirect && (
          <Paragraph type="secondary" style={{ marginTop: 8 }}>
            Redirecting to your onboarding tasks…
          </Paragraph>
        )}
      </Card>
    </div>
  );
};

export default KycSuccess;
